import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import CustomerLogin from './components/CustomerLogin';
import Dashboard from './components/Dashboard';
import CustomerDashboard from './components/CustomerDashboard';
import './App.css';

function App() {
  const isCustomer = localStorage.getItem('isCustomer') === 'true';
  const userRole = localStorage.getItem('userRole');

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route 
          path="/dashboard" 
          element={
            userRole ? (
              isCustomer ? <CustomerDashboard /> : <Dashboard />
            ) : (
              <Navigate to="/" />
            )
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;